import React from 'react'
import CustomTooltip from '../../CustomTooltip'
import WarningAmberIcon from '@mui/icons-material/WarningAmber'
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline'
import { red, yellow } from '../../../colors'

export enum CellWarningType {
  WARNING = 'warning',
  ERROR = 'error',
}

interface CellWarningProps {
  keyType: CellWarningType
  message: string
}

const iconStyles = {
  [CellWarningType.WARNING]: { color: yellow[150], Icon: WarningAmberIcon },
  [CellWarningType.ERROR]: { color: red[700], Icon: ErrorOutlineIcon }
}

const CellWarning: React.FC<CellWarningProps> = ({ keyType, message }) => {
  const icon = iconStyles[keyType]
  const IconComponent = icon.Icon

  return (
        <CustomTooltip title={message} placement="top">
            <IconComponent sx={{ color: icon.color, mr: 3, fontSize: 22, cursor: 'pointer', fontWeight: '600' }} />
        </CustomTooltip>
  )
}

export default CellWarning
